<template>
  <div>
    <div id="dropdown" />
    <div class="md:flex md:flex-col min-h-screen">
      <div class="md:flex md:flex-col h-full">
        <!-- Header -->
        <header class="md:flex md:flex-shrink-0 border-b shadow-sm">
          <!-- Logo Area -->
          <div class="flex items-center justify-between md:justify-center md:w-56 bg-white p-4">
            <Link class="block" href="/">
              <logo :src="auth.user.account.logo" class="fill-white max-h-16 w-auto" width="120" height="80" />
            </Link>
            <!-- Mobile Menu Button -->
            <dropdown class="md:hidden" placement="bottom-end">
              <template #default>
                <button class="p-2 rounded-lg hover:bg-gray-100">
                  <svg class="w-6 h-6 text-gray-600" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
                  </svg>
                </button>
              </template>
              <template #dropdown>
                <div class="mt-2 px-8 py-4 bg-white rounded-lg shadow-lg">
                  <main-menu :role="auth.user.role" :account="auth.user.account" />
                </div>
              </template>
            </dropdown>
          </div>

          <!-- Top Navigation Bar -->
          <nav class="flex items-center justify-between p-4 w-full bg-white md:px-12 md:py-4">
            <!-- Exchange Rate -->
            <div class="text-sm md:text-base font-medium text-gray-600">
              1$ = {{ change }} BsD
            </div>

            <!-- User Menu -->
            <dropdown class="relative" placement="bottom-end">
              <template #default>
                <button class="group flex items-center space-x-2 p-2 rounded-lg hover:bg-gray-100">
                  <div class="text-gray-700 group-hover:text-blue-600">
                    <span>{{ auth.user.first_name }}</span>
                    <span class="hidden md:inline">&nbsp;{{ auth.user.last_name }}</span>
                  </div>
                  <icon class="w-5 h-5 text-gray-400 group-hover:text-blue-600" name="cheveron-down" />
                </button>
              </template>
              <template #dropdown>
                <div class="mt-2 py-2 w-48 bg-white rounded-lg shadow-xl border">
                  <Link class="block px-4 py-2 text-sm text-gray-700 hover:text-white hover:bg-blue-500" :href="`/users/${auth.user.id}/edit`">Mi perfil</Link>
                  <Link v-if="auth.user.role == 'admin'" class="block px-4 py-2 text-sm text-gray-700 hover:text-white hover:bg-blue-500" href="/users">Usuarios</Link>
                  <Link v-if="auth.user.role == 'admin'" class="block px-4 py-2 text-sm text-gray-700 hover:text-white hover:bg-blue-500" :href="`/accounts/${auth.user?.account?.id}`">Cuenta</Link>
                  <Link class="block px-4 py-2 text-sm text-gray-700 hover:text-white hover:bg-blue-500" href="/logout" method="delete" as="button">Cerrar sesión</Link>
                </div>
              </template>
            </dropdown>
          </nav>
        </header>

        <!-- Main Content Area -->
        <div class="md:flex md:flex-grow md:overflow-hidden">
          <!-- Sidebar -->
          <main-menu 
            :account="auth.user.account" 
            :role="auth.user.role"
            class="hidden md:block flex-shrink-0 p-6 w-56 overflow-y-auto rounded-lg transition-all" 
            :style="{'backgroundColor': auth.user.account.sidebarColor ?? 'white'}" 
          />

          <!-- Main Content -->
          <main class="px-4 py-8 md:flex-1 md:p-12 md:overflow-y-auto bg-[#ecf0f1]" scroll-region>
            <flash-messages />
            <slot />
          </main>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.background {
  background-color: #bbe8e1;
}
</style>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Logo from '@/Shared/Logo'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from '@/Shared/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'
import BottomMenu from './BottomMenu.vue'

export default {
  components: {
    Dropdown,
    FlashMessages,
    Icon,
    Link,
    Logo,
    MainMenu,
    BottomMenu
  },
  props: {
    auth: Object,
    change: Number
  },
  data() {
    return {
      date: '',
      time: ''
    }
  },
  mounted() {
    
  },
  methods: {
    zeroPadding(num, digit) {
      return String(num).padStart(digit, '0')
    },
    update() {
      const now = new Date()
      const hours = this.zeroPadding(now.getHours(), 2)
      const minutes = this.zeroPadding(now.getMinutes(), 2) 
      const seconds = this.zeroPadding(now.getSeconds(), 2)
      return `${hours}:${minutes}:${seconds}`
    }
  }
}
</script>
